import { render, staticRenderFns } from "./RoleData.vue?vue&type=template&id=db4a0910&"
import script from "./RoleData.vue?vue&type=script&lang=ts&"
export * from "./RoleData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports